export function getCaSignUrl(data, pdfFile, uploadUrl) {
  const { bizfiledId, caId: type, isTbr, webURL, kbxmId, bdId, jgdm, lx, ryjs, userName, systemCode } = data || {}

  const signUserName = encodeURIComponent(userName)
  const signPdfUrl = pdfFile || `${webURL}api/v2/jc/tyhf/pdfview/${bizfiledId}/${lx}`
  const signUploadUrl = uploadUrl || `${webURL}api/v2/jc/tyhf/caSignDqcz?bizfiledId=${bizfiledId}&userName=${signUserName}&kbxmId=${kbxmId}&bdId=${bdId}&jgdm=${jgdm}&lx=${lx}&ryjs=${ryjs}`

  const signParam = `?isHy=true&type=${type}&isTbr=${isTbr}&userName=${signUserName}&blockId=${bdId}&systemCode=${systemCode}&pdfUrl=${signPdfUrl}&uploadUrl=${encodeURIComponent(signUploadUrl)}`
  const signUrl = process.env.NODE_ENV === "development" 
    ? 'https://tca.zhaotx.cn/test'
    : 'https://ca.zhaotx.cn/test'
  
  console.log('sign:', { data, signPdfUrl, signUploadUrl, signParam, signUrl })
  return signUrl + signParam
}